import * as Mui from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { FieldArray } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AutocompleteSelectField, InputField } from '../../../../components/form';
import { IconInfo, IconTrash } from '../../../../components/svg';

export const OrganizationProfile = ({ formikProps }) => {
    const { t } = useTranslation();

    const { countryList } = useSelector(state => state.shared);



    return <Mui.Box>
        <Mui.Typography
            component="h5"
            variant="h5"
            className="mb-3 font-weight-medium"
        >
            {t("ORGANIZATION.ONBOARD.PROFILE.TITLE")}
        </Mui.Typography>

        <Mui.Grid container spacing={4}>
            <Mui.Grid item xs={12} sm={6} className="form-group">
                <InputField
                    name="name"
                    type="text"
                    label={t("ORGANIZATION.FORM.PLACEHOLDER.NAME")}
                    onChange={(e) => {
                        formikProps.setFieldValue('name', e.target.value)
                        //create subdomain from name
                        const subdomain = e.target.value.toLowerCase().replace(/ /g, '-')
                        const url = process.env.REACT_APP_API_BASE_URL.split('.').slice(1).join('.')
                        const websiteId = `https://${subdomain}.${url}`

                        formikProps.setFieldValue('websiteId', websiteId)
                    }}
                />
            </Mui.Grid>
            <Mui.Grid item xs={12} sm={6} className="form-group">
                <InputField
                    name="number"
                    type="text"
                    label={t("ORGANIZATION.FORM.PLACEHOLDER.NUMBER")}
                />
            </Mui.Grid>
            <Mui.Grid item xs={12} className="form-group">
                <InputField
                    name="websiteId"
                    type="text"
                    label={t("ORGANIZATION.ONBOARD.PROFILE.SUBDOMAIN")}
                    disabled
                // placeholder={t("SETTING.FORM.PLACEHOLDER.STREET_ADDRESS")}
                />
            </Mui.Grid>
        </Mui.Grid>


        <Mui.Typography
            component="h5"
            variant="h5"
            className="mb-3 mt-3 font-weight-medium"
        >
            {t("ORGANIZATION.ONBOARD.PROFILE.ADDRESS_TITLE")}
        </Mui.Typography>
        <Mui.Grid container spacing={4}>
            <Mui.Grid item xs={12} className="form-group">
                <InputField
                    name="streetName"
                    type="text"
                    label={t("SETTING.FORM.STREET_ADDRESS")}
                // placeholder={t("SETTING.FORM.PLACEHOLDER.STREET_ADDRESS")}
                />
            </Mui.Grid>
            <Mui.Grid item xs={12} sm={6} className="form-group">
                <InputField
                    name="postalCode"
                    type="text"
                    label={t("ORGANIZATION.FORM.PLACEHOLDER.POSTAL_CODE")}
                />
            </Mui.Grid>
            <Mui.Grid item xs={12} sm={6} className="form-group">
                <InputField
                    name="city"
                    type="text"
                    label={t("ORGANIZATION.FORM.PLACEHOLDER.CITY")}
                />
            </Mui.Grid>
            <Mui.Grid item xs={12} className="form-group">
                <AutocompleteSelectField
                    disabled={false}
                    name="countryId"
                    label={t("USER.FORM.PLACEHOLDER.COUNTRY")}
                    options={countryList || []}
                />
                <Mui.Typography
                    component="h6"
                    variant="body2"
                    className="font-weight-light text-color-danger"
                >({t('ORGANIZATION.FORM.CANNOT_EDIT_COUNTRY')})</Mui.Typography>
            </Mui.Grid>
        </Mui.Grid>

        <FieldArray
            name="adminUser"
            render={(arrayHelpers) => (
                <>
                    <Mui.Box className="mt-3 mb-3 d-flex justify-content-between">
                        <Mui.Box>
                            <Mui.Typography
                                component="h5"
                                variant="h5"
                                className="mb-1 font-weight-medium"
                            >
                                {t("ORGANIZATION.ONBOARD.PROFILE.ADMINS_TITLE")}
                            </Mui.Typography>
                            <Mui.Typography
                                component="h6"
                                variant="h6"
                                className="mb-3 font-weight-normal text-color-grey"
                            >
                                {t("ORGANIZATION.ONBOARD.PROFILE.ADMINS_DESC")}
                            </Mui.Typography>
                        </Mui.Box>
                        <Mui.Box
                            className='d-flex align-items-center pointer'
                            gridGap={5}
                            onClick={() => arrayHelpers.push({ name: "", email: "" })}
                        >
                            <Add style={{ fontSize: '1.7rem', border: '1.5px solid #392ed6', color: '#392ed6', borderRadius: '50%' }} />
                            <Mui.Typography
                                component="h6"
                                variant="h6"
                                className="font-weight-medium text-color-primary"
                            >
                                {t("ORGANIZATION.ONBOARD.PROFILE.ADD_ADMIN")}
                            </Mui.Typography>
                        </Mui.Box>
                    </Mui.Box>
                    <Mui.Grid container spacing={4}>
                        {formikProps.values.adminUser.map((item, index) => (
                            <React.Fragment key={index}>
                                <Mui.Grid item xs={12} sm={5} className="form-group" >
                                    <InputField
                                        name={`adminUser.${index}.name`}
                                        type="text"
                                        label={t("ORGANIZATION.FORM.PLACEHOLDER.ADMIN_NAME")}
                                    />
                                </Mui.Grid>
                                <Mui.Grid item xs={12} sm={5} className="form-group" >
                                    <InputField
                                        name={`adminUser.${index}.email`}
                                        type="text"
                                        label={t("ORGANIZATION.FORM.PLACEHOLDER.ADMIN_EMAIL")}
                                    />
                                </Mui.Grid>
                                <Mui.Grid
                                    item
                                    xs={2}
                                    className="form-group"
                                >

                                    {index !== 0 ? (
                                        <Mui.Button
                                            size="small"
                                            disableElevation
                                            onClick={() => arrayHelpers.remove(index)}
                                            className="font-weight-normal no-color-btn"
                                        >
                                            {t("COMMON.REMOVE")}
                                            <span className="ml-1 line-height-null">
                                                <IconTrash />
                                            </span>
                                        </Mui.Button>
                                    ) : null}
                                </Mui.Grid>
                            </React.Fragment>

                        ))}
                    </Mui.Grid>
                </>
            )}
        />


        <Mui.Box
            style={{
                border: '2px solid #8A97DE',
                borderRadius: '10px',
                backgroundColor: '#F5F6FA',
            }}
            className='d-flex align-items-center p-2 mt-4'
            gridGap={10}
        >
            <IconInfo stroke="#392ed6" />
            <Mui.Typography variant="body1" className="font-weight-semibold text-color-primary">
                {t("ORGANIZATION.ONBOARD.PROFILE.INFO")}
            </Mui.Typography>
        </Mui.Box>

    </Mui.Box>
}